import { ChannelSettingSectionHeader } from './ChannelSettingSectionHeader';
import { ChannelSettingToggleTextarea } from './ChannelSettingToggleTextarea';
import { Separator } from '@frontend/components/ui/separator';
import { Switch } from '@frontend/components/ui/switch';

export function ChannelContextSection({
  contextEnabled,
  contextValue,
  onContextToggle,
  onContextChange,
  teamContextExcluded,
  onTeamContextExcludedChange,
  isReadOnly = false,
}: {
  contextEnabled: boolean;
  contextValue: string;
  onContextToggle: (enabled: boolean) => void;
  onContextChange: (value: string) => void;
  teamContextExcluded: boolean;
  onTeamContextExcludedChange: (excluded: boolean) => void;
  isReadOnly?: boolean;
}) {
  return (
    <>
      {/* Channel Context Setting */}
      <ChannelSettingToggleTextarea
        title="Channel Context"
        description="Add specific knowledge the agent should know in this channel"
        isEnabled={contextEnabled}
        value={contextValue}
        onToggle={onContextToggle}
        onValueChange={onContextChange}
        placeholder="Add channel-specific context (optional)"
        minRows={3}
        helperText="Channel-specific context is additive to team context."
        isReadOnly={isReadOnly}
      />

      <Separator />

      {/* Team Context Setting */}
      <div>
        <div className="flex items-center justify-between">
          <ChannelSettingSectionHeader
            title="Exclude Team Context"
            description="Don't include team-wide context for this channel."
          />
          <Switch
            checked={teamContextExcluded}
            disabled={isReadOnly}
            onCheckedChange={(checked) =>
              !isReadOnly && onTeamContextExcludedChange(checked)
            }
          />
        </div>
      </div>
    </>
  );
}
